import React from 'react';
import { Conditional, Button, StatusLabel } from '@cashfree-intl/coherent';

import { startCase } from 'lodash';

// Utils
import { getRowStatusType } from './utils';

// Constants
import { WHITELISTING_STATUS } from './constants';
import { DOMAIN_REF, REJECTION_STATUSES } from './constants';

// Components
import CustomIcons from 'components/CustomIcons';

// Types
import { WhitelistTableItemType, WhitelistTableResponseType } from './types';
import { ICON_NAME } from 'components/CustomIcons/types';

export const getTableData = (
  domains: WhitelistTableResponseType,
  showActions: boolean,
  isLoading: boolean,
  onActionClick: (rowData: WhitelistTableItemType) => () => void,
) => {
  if (!isLoading && domains && domains.length) {
    const formattedData = domains
      .sort((a, b) => (new Date(a.addedOn) < new Date(b.addedOn) ? 1 : -1))
      .map(rowData => ({
        ...rowData,
        id: rowData.id,
        ticketStatus: (
          <Conditional if={rowData.ticketStatus}>
            <StatusLabel
              $status={getRowStatusType(rowData.ticketStatus)}
              filled={true}
            >
              {startCase(rowData.ticketStatus.toLowerCase())}
            </StatusLabel>
          </Conditional>
        ),
        referenceType: rowData.referenceType === DOMAIN_REF ? 'Website' : 'App',
        actions: showActions ? (
          <Conditional
            if={
              REJECTION_STATUSES.includes(rowData.ticketStatus) &&
              rowData.version
            }
          >
            <Button dangerSecondary onClick={onActionClick(rowData)}>
              {rowData.ticketStatus === WHITELISTING_STATUS.REJECTED
                ? 'View'
                : 'Fix Issues'}
            </Button>
          </Conditional>
        ) : (
          undefined
        ),
      }));
    return formattedData;
  }
  return [];
};

export const getNoRecordsObj = (
  domains: WhitelistTableResponseType,
  isLoading: boolean,
) => {
  if (!isLoading && !domains.length) {
    return {
      icon: <CustomIcons componentName={ICON_NAME.WEBSITE} />,
      text: 'You have not whitelisted any website or app yet!',
      description: <span>Add new to view it here.</span>,
    };
  }
};
